import React, { Suspense, useEffect } from "react";
import {HashRouter as Router, Routes, Route, useNavigate} from "react-router-dom";
import Registration from "../pages/Registration/Registration";
import Login from "../pages/Login/Login";
import Dashboard from "../pages/Dashboard/Dashboard";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import R114ReportsAttendanceRecordSheet from '../pages/Dashboard/Contents/Reports/R114Reports/R114ReportsAttendanceRecordSheet';
import TutionFeeChalanForm from "../pages/Dashboard/Contents/ChalanForms/TutionFeeChalanForm";
import TutionFeeChalanFormForMobile from "../pages/Dashboard/Contents/ChalanForms/TutionFeeChalanFormForMobile";
import CloseTutionFeeChalanFormForMobile from "../pages/Dashboard/Contents/ChalanForms/CloseTutionFeeChalanFormForMobile";
import PrivateRoute from "./PrivateRoutes";

const CheckLogin = () => {
  const lmsToken = localStorage.getItem("lmsToken");
  const navigate = useNavigate();

  useEffect(() => {
    if (lmsToken) {
      navigate("/dashboard", { replace: true });
    }
  }, [lmsToken, navigate]);

  if (lmsToken) {
    return null;
  }

  return <Login />;
};

const AppRoute = () => {

  return (
    <>
      <Router>
        <Suspense fallback={<p>Loading...</p>}>
          <Routes>
            <Route path="/login" element={<CheckLogin />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/mobile-challan-view" element={<TutionFeeChalanFormForMobile />} />
            <Route path="/close-mobile-challan-view" element={<CloseTutionFeeChalanFormForMobile />} />
            <Route path="/R114ReportsAttendanceRecordSheet/:id" element={<PrivateRoute><R114ReportsAttendanceRecordSheet /></PrivateRoute>} />
            <Route path="/challan-view" element={<PrivateRoute><TutionFeeChalanForm /></PrivateRoute>} />
            <Route path="*" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
};


export default AppRoute;
